import { handleActions } from "redux-actions";
import { setEnableDownload } from "../actions/actions";

export default handleActions(
  {
    [setEnableDownload]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
